import Axios from "axios";

const API = Axios.create({
  // baseURL: "https://api.yours.impulsiveweb.life/",
  // baseURL: "https://api.yours.devstudioonline.com/",
  baseURL: "https://api.yours.house/",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "",
  },
});

API.interceptors.request.use(
  function (config: any) {
    const token = window.localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      delete config.headers["Authorization"];
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

API.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 401) {
        handleLogout();
      }
      if (
        status === 500 &&
        data.message &&
        (data.message.includes("jwt expired") ||
         data.message.includes("JsonWebTokenError") ||
         data.message.includes("invalid token"))
      ) {
        handleLogout();
      }
    }
    return Promise.reject(error);
  }
);

function handleLogout() {
  window.localStorage.removeItem("token");
  window.location.href = "/login";
}


export default API;
